import React, { ReactNode } from "react";
import { RolesTypes } from "@app/pages/users/utils/helpers";
import usePermission from "@app/context/PermissionContext";

interface PermissionGateProps {
  children: ReactNode;
  permissions: RolesTypes[];
}

export const PermissionComponentGate = ({
  children,
  permissions,
}: PermissionGateProps) => {
  const { isAdmin, isSuperAdmin, isTechnical } = usePermission();

  const userRoles = [
    isAdmin && RolesTypes.ADMIN,
    isSuperAdmin && RolesTypes.SUPER_ADMIN,
    isTechnical && RolesTypes.TECHNICAL,
  ].filter(Boolean) as RolesTypes[];

  const hasPermission = userRoles.some((role) => permissions.includes(role));

  if (!hasPermission) {
    return null;
  }

  return <>{children}</>;
};
